import { useEffect } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Seo from "@/components/feature/Seo";
import FaqAccordion, { buildFaqPageSchema } from "@/components/feature/FaqAccordion";
import { brand } from "@/mocks/siteData";
import { usePublicFaqs } from "@/hooks/usePublicContent";
import { partnerFaqs } from "./partnerFaqs";
import PartnerHero from "./components/PartnerHero";
import PartnerBenefits from "./components/PartnerBenefits";
import PartnerSteps from "./components/PartnerSteps";
import PartnerForm from "./components/PartnerForm";

export default function Partner() {
  const faqs = usePublicFaqs("Partner", partnerFaqs);

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <div className="min-h-screen bg-background-50 overflow-x-hidden">
      <Seo
        title={`Become a Farm Partner — Host Visitors & Earn | ${brand.name}`}
        description="Partner with Rythugaru to turn your farm into a visitor experience. Free to join, no hidden fees — we help with listings, experiences, bookings and fair, prompt payments."
        path="/farm-partner"
        keywords="become a farm partner, farm stay host India, agri tourism partnership, farm host Konaseema, farmer income opportunity, farm experience hosting"
        image="https://readdy.ai/api/search-image?query=Proud%20South%20Indian%20farmer%20standing%20with%20arms%20crossed%20in%20front%20of%20a%20lush%20green%20farm%20at%20early%20morning%2C%20confident%20welcoming%20expression%2C%20painterly%20stylized%20earthy%20green%20tones%2C%20dignified%20rural%20portrait%20in%20landscape%2C%20flooded%20with%20golden%20sunrise%20light%2C%20warm%20amber%20sunrays%20and%20soft%20glow%2C%20misty%20atmospheric%20haze%2C%20deep%20rich%20shadows%2C%20vivid%20saturated%20lush%20green%2C%20high%20contrast%20cinematic%20golden%20hour%20richness%2C%20ultra%20detailed&nocache=true&width=1920&height=1080&seq=partner-hero&orientation=landscape"
        structuredData={buildFaqPageSchema(faqs)}
      />
      <Navbar />
      <main>
        <PartnerHero />
        <PartnerBenefits />
        <PartnerSteps />
        <FaqAccordion
          faqs={faqs}
          eyebrow="Partner Questions"
          title="Becoming a Farm Partner FAQs"
          intro="What farmers ask us most before joining — costs, what qualifies, how listings work, staying in control of your calendar and getting paid."
        />
        <PartnerForm />
      </main>
      <Footer />
    </div>
  );
}